export interface Attachment {
  id: string;
  name: string;
  size: number;
  file: File;
  fileId?: string;
  s3Url?: string;
}

export const SUPPORTED_ATTACHMENT_EXTENSIONS = [
  '.csv',
  '.doc',
  '.docx',
  '.heic',
  '.jfif',
  '.jpeg',
  '.jpg',
  '.mov',
  '.mp4',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.rtf',
  '.txt',
  '.wav',
  '.xls',
  '.xlsx'
];

export const SUPPORTED_ATTACHMENT_MIME_TYPES = [
  'text/csv',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/heic',
  'image/jfif',
  'image/jpeg',
  'image/jpg',
  'video/quicktime',
  'video/mp4',
  'application/pdf',
  'image/png',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/rtf',
  'text/plain',
  'audio/wav',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

export const MAX_TOTAL_ATTACHMENT_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB total for all attachments combined
export const MAX_ATTACHMENT_COUNT = 10;
